// services/github.js
import axios from 'axios';

const GITHUB_API = 'https://api.github.com';
const GITHUB_USERNAME = 'developer13-art';

export const githubService = {
  async getRepos() {
    try {
      const response = await axios.get(`${GITHUB_API}/users/${GITHUB_USERNAME}/repos`, {
        params: {
          sort: 'updated',
          per_page: 10
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching GitHub repos:', error);
      return [];
    }
  },

  async getUserStats() {
    try {
      const [userRes, reposRes] = await Promise.all([
        axios.get(`${GITHUB_API}/users/${GITHUB_USERNAME}`),
        axios.get(`${GITHUB_API}/users/${GITHUB_USERNAME}/repos`)
      ]);

      const totalStars = reposRes.data.reduce((acc, repo) => acc + repo.stargazers_count, 0);
      const languages = reposRes.data.reduce((acc, repo) => {
        if (repo.language) {
          acc[repo.language] = (acc[repo.language] || 0) + 1;
        }
        return acc;
      }, {});

      return {
        repos: reposRes.data.length,
        stars: totalStars,
        followers: userRes.data.followers,
        following: userRes.data.following,
        languages: Object.keys(languages).slice(0, 10),
        contributions: userRes.data.public_repos || 0
      };
    } catch (error) {
      console.error('Error fetching GitHub stats:', error);
      return null;
    }
  }
};